"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
var _variables = require("./variables");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var size = 24;
var arrowHeight = 20;
var marginPadding = 2 * 2 + 2 * 2;
var iconSize = {
  width: "".concat(size, "px"),
  height: "".concat(size, "px")
};
var _default = exports["default"] = (0, _nano.sheet)({
  container: {
    position: 'relative'
  },
  menu: {
    position: 'absolute',
    width: '200px',
    minHeight: '100px',
    backgroundColor: _variables.dropdownMenuBackground,
    borderRadius: '4px',
    top: "".concat(size + marginPadding + arrowHeight, "px"),
    padding: '2px',
    margin: 0,
    listStyleType: 'none',
    transition: 'visibility 0.5s',
    transitionDelay: '1s !important',
    zIndex: _variables.zIndexes.get('popover'),
    boxShadow: '#aaa 1px 1px 5px'
  },
  menu_left: {
    left: "-".concat(marginPadding / 2, "px")
  },
  menu_center: {
    left: '50%',
    transform: 'translateX(-50%)',
    '& .dropdown-menu__arrow': {
      left: '50%',
      transform: 'translateX(-50%)'
    }
  },
  menu_right: {
    right: "-".concat(marginPadding / 2, "px"),
    '& .dropdown-menu__arrow': {
      right: 0
    }
  },
  toggler: {
    '&.button--icon': _objectSpread(_objectSpread({}, iconSize), {}, {
      padding: '2px',
      margin: '2px',
      boxSizing: 'content-box',
      '&::before': _objectSpread({}, iconSize)
    })
  },
  arrow: {
    position: 'absolute',
    top: '-20px',
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',
    borderBottom: "".concat(arrowHeight, "px solid ").concat(_variables.dropdownMenuBackground),
    width: 0,
    height: 0,
    filter: 'drop-shadow(0 -1px 1px #aaa)'
  }
});